/**
 * @generated SignedSource<<3c7bb3a426d94c731791394b95a99685>>
 * @relayHash e2c38091af89923a791013580f86edb4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bdf32afb879bc51fb9bd9cb529f00820a4904fa5231db787cbc331c30c6aa4d9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bdf32afb879bc51fb9bd9cb529f00820a4904fa5231db787cbc331c30c6aa4d9",
    "metadata": {},
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
